<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16.873,6.375V4.873a4.873,4.873,0,0,0-9.746,0V6.375H2.9863V24H21.0137V6.375ZM9.627,4.873a2.373,2.373,0,1,1,4.746,0V6.375H9.627ZM18.5137,21.5H5.4863V8.875H18.5137Z"/></svg>
</template>